var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};

OCS.Viewer.Classes.TrackerMapFeature = new Class({
    tracker_active: false,
    tracker_layer: null,
    tracker_point: null,
    add_tracker: function () {
        if (!this.is_tracker_active()) {
            this.tracker_point = new ol.Feature({
                geometry: new ol.geom.Point([0, 0]),

            });
            this.tracker_point.setStyle(new ol.style.Style({
                image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
                    scale: 0.75,
                    rotateWithView: true,
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    opacity: 1,
                    size: [48, 48],
                    src: "dist/images/cross-mouse-pointer.png",
                    type: 'Icon'
                }))
            }));
            this.tracker_layer = new ol.layer.Vector({
                source: new ol.source.Vector({
                    features: [this.tracker_point]
                })
            });
            this.tracker_layer.setZIndex(9999);
            this.ol_object.addLayer(this.tracker_layer);
            this.set_tracker_active(true);
            this.mouse_tracker_event_key = this.add_change_position_event(this.on_tracker_change_mouse_position, this);
        }
    },
    on_tracker_change_mouse_position: function (event) {
        // When the mouse is over the other map and not this map
        var position = event.target.get(event.key);
        if (!this.mouse_over_map) {
            this.tracker_point.setGeometry(new ol.geom.Point(position));
            this.tracker_layer.setVisible(true);
        } else {
            OCS.Viewer.Functions.get_controller_manager().set_linked_mouse_position(position);
            this.tracker_layer.setVisible(false);
        }
    },
    remove_tracker: function () {
        if (this.tracker_layer) {
            this.ol_object.removeLayer(this.tracker_layer);
            this.remove_event(this.mouse_tracker_event_key);
            this.set_tracker_active(false);
            this.mouse_tracker_event_key = null;
            this.tracker_layer = null;
        }
    },
    is_tracker_active: function () {
        return this.tracker_active;
    },
    set_tracker_active: function (cond) {
        this.tracker_active = cond;
    },
});